import React from "react"
import styled from "styled-components"
import { FaArrowCircleUp } from "react-icons/fa"

const ToTopButton = ({ toTopClick }) => {
  return (
    <Wrapper>
      <FaArrowCircleUp
        onClick={toTopClick}
        css={`
          font-size: clamp(3rem, 8vw, 5rem);
          color: #fff;
        `}
      />
    </Wrapper>
  )
}

export default ToTopButton

const Wrapper = styled.div`
  position: fixed;
  z-index: 999;
  right: 3vw;
  bottom: 6.5vh;
  cursor: pointer;
  opacity: 0.5;
  transition-duration: 0.5s;

  &:hover {
    opacity: 1;
  }

  @media screen and (min-width: 768px) {
    bottom: 5.5vh;
  }
`
